/** Imports */
import {z} from 'zod';
import {zMongoObject} from '@/types/utils';


/** Types */
export type User = z.infer<typeof zUser>;
export type SignUpMethod = z.infer<typeof zUser.shape.method>;


/// Zod schemas
export const zUser = zMongoObject.extend({
    method: z.enum(['EMAIL', 'GOOGLE']),
    username: z.string(),
    email: z.email(),
    emailIsVerified: z.boolean(),
    socialId: z.string().optional(),
    registerDate: z.instanceof(Date),
    lastSignInDate: z.instanceof(Date),
    passwordHash: z.string().optional(),
    passwordSalt: z.string().optional(),
    resetToken: z.string().optional(),
    deletedFlagSince: z.instanceof(Date).optional(),
    deletedFlagToken: z.string().optional(),
    isAdmin: z.boolean(),
    emailOTP: z.string().optional(),
    systemOTP: z.string().optional(),
    emailOTPExpiresAt: z.instanceof(Date).optional(),
    emailOTPGeneratedAt: z.instanceof(Date).optional(),
    emailOTPWindowExpiresAt: z.instanceof(Date).optional(),
    emailOTPAttempts: z.number().int().optional(),
    emailOTPPurpose: z.enum(['password-reset', 'sensitive-operation']).optional(),
    systemOTPExpiresAt: z.instanceof(Date).optional(),
    systemOTPPurpose: z.enum(['password-reset', 'sensitive-operation']).optional(),
});
